import { render, staticRenderFns } from "./AcceptInvitation.vue?vue&type=template&id=6a3d40ce&scoped=true&"
import script from "./AcceptInvitation.vue?vue&type=script&lang=js&"
export * from "./AcceptInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AcceptInvitation.vue?vue&type=style&index=0&id=6a3d40ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d40ce",
  null
  
)

export default component.exports